<div class="product-container">
    <div class="flex-col">
        <product-image
            imageAutomationTag="productImage"
            [imageClass]="'img-fluid'"
            [images]="product.productImages"
            [imageType]="'productImage'"
            [imageSize]="'LG'"
            [imageOrder]="0"
            [routerLink]="[PRODUCT_ROUTE, ProductUtil.convertUsanaIdToDash(product.usanaId)]">
        </product-image>
        <div class="product-descriptions productMeta">
            <div class="product-buy-box-container">
                <h2 class="heading-3 product-name" automation-tag="productName"
                    [innerHTML]="productGroup.productDescription.name" [routerLink]="[PRODUCT_ROUTE, ProductUtil.convertUsanaIdToDash(product.usanaId)]"></h2>
                @if (!productDetails || productDetails.length == 0) {
                    <p class="short-description" [innerHTML]="product.productDescription.shortDescription"></p>
                } @else {
                    <div class="product-great-for">
                        @for (productDetail of productDetails; track trackByFn) {
                            <div>
                                <h4>{{productDetail.title}}</h4>
                                <ul>
                                    @for (description of productDetail.descriptions; track trackByFn) {
                                        <li>{{description}}</li>
                                    }
                                </ul>
                            </div>
                        }
                    </div>
                }

                <product-buy-box [productGroup]="productGroup" [product]="product" [productQty]="productShareQty" [isPdp]="false"
                                 (productAddedEvent)="productAddedToCart()" [onUpdateProduct]="updateSelectedProduct.bind(this)"></product-buy-box>
            </div>

            <a class="learn-more" href="javascript:void(0)" (click)="toggleLearnMore()">
                <span translate="cart.learn.more"></span>&nbsp;
                <i class="fa-solid" [ngClass]="showMoreDetails ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
            </a>

            <div class="more-details" [hidden]="!showMoreDetails">
                @if (bodyBenefitTags?.length > 0) {
                    <div class="page-section body-benefits">
                        <h2 class="heading-3" translate="cart.product.body.benefit"></h2>
                        <ul>
                            @for (tag of bodyBenefitTags; track tag.id) {
                                <li>
                                    <img class="body-benefit"
                                         [src]="tag.imagePath" [alt]="tag.translationTag | translate" placement="bottom"
                                         attr.automation-tag="'bodyBenefit'-{{tag.id}}"/>
                                    <span [translate]="tag.translationTag"></span>
                                </li>
                            }
                        </ul>
                    </div>
                }

                @if (product?.productDescription?.longDescription) {
                    <div class="page-section product-description">
                        <h2 class="heading-3" translate="cart.product.moreinformation"></h2>
                        <div class="productDetails">
                            <p class="description" [innerHTML]="product.productDescription.longDescription | safeHtml"
                               automation-tag="longDescription"></p>
                        </div>
                    </div>
                }

                @if (product?.supplementalInfo?.path) {
                    <div class="page-section supplement-facts">
                        <h2 class="heading-3" translate="cart.product.supplementfacts"></h2>
                        <p translate="cart.product.supplementfacts.learn.more"></p>
                        <a [href]="product.supplementalInfo.path" target="_blank"
                           translate="cart.product.supplementfacts.download"></a>
                    </div>
                }
            </div>
        </div>
    </div>
</div>
